module.exports = __webpack_public_path__ + "img/beautyEyes.c01a10a8.png";